<template>
    <v-form ref="form">
        <v-row wrap>
            <v-col cols="12">
                <Dropzone v-model="file" type="single" :rules="$props.doNotRequireFile ? [] : [(v) => !!v || 'File is required']">
                    <template #message>
                        Accepts: Image, PDF, Document, Powerpoint, or Video files
                    </template>
                </Dropzone>
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="newDoc.DocTitle" label="Title*" :rules="[(v) => !!v || 'File name is required']" />
            </v-col>
            <v-col cols="12">
                <v-text-field v-model="newDoc.DocDesc" label="Description*" :rules="[(v) => !!v || 'File description is required']" />
            </v-col>
            <v-col cols="12" v-if="isMarketingResource">
                <DocumentGroupSelect label="Group*" v-model="newDoc.SubCategory" :rules="[(v) => (!!v && v.length > 0) || 'File group is required']" />
            </v-col>
            <v-col cols="12" v-if="isMarketingResource">
                <DocumentTagsSelect v-model="newDoc.DocumentTags" />
            </v-col>
            <v-col cols="12" v-if="isMarketingResource">
                <v-select v-model="newDoc.Audience" label="Audience*" :items="['Agent', 'Customer']" :rules="[(v) => !!v || 'Audience is required']" />
            </v-col>
            <v-col cols="12">
                <q-tenant-select label="Tenant*" v-model="newDoc.PermissionTenantIDs" multiple :with-all="true" :rules="[(v) => !!v || 'Tenant is required']"></q-tenant-select>
            </v-col>
            <v-col cols="12">
                <v-checkbox v-model="newDoc.SecureDocumentInd" label="Secure Document"></v-checkbox>
            </v-col>
            <v-col cols="12" class="d-flex">
                <v-btn color="primary" @click="$refs.form.validate() && $emit('submit', {
                    file,
                    meta: newDoc,
                })">Save Changes</v-btn>
                <v-spacer></v-spacer>
                <slot name="right-to-save" />
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import { acceptedFiles } from './acceptedFiles.ts'
import QTenantSelect from '../utils/QTenantSelect.vue'
import QFileUpload from '../utils/QFileUpload.vue'
import Dropzone from './Dropzone.vue'
import DocumentTagsSelect from './DocumentTagsSelect.vue'
import DocumentGroupSelect from './DocumentGroupSelect.vue'

export default {
    components: { QTenantSelect, QFileUpload, Dropzone, DocumentTagsSelect, DocumentGroupSelect },

    props: {
        doc: {
            type: Object,
            required: true
        },
        /** Show only meta data fields. Disallow user to load new file */
        onlyMeta: {
            type: Boolean,
            default: false
        },
        doNotRequireFile: { 
            type: Boolean,
            default: false
        }
    },

    data() {
        return { 
            acceptedFiles,
            file: null,
            newDoc: null
        }
    },

    computed: {
        isMarketingResource() {
            return this.doc.CategoryName === "Marketing Resource Library"
        }
    },

    watch: {
        'newDoc.PermissionTenantIDs'() {
            if (this.newDoc.PermissionTenantIDs && this.newDoc.PermissionTenantIDs.length === 1) {
                this.newDoc.TenantID = this.newDoc.PermissionTenantIDs[0]
            }
        },
        doc: {
            handler: function (newDoc) {
                if (newDoc) {
                    this.newDoc = { ...newDoc }
                } else {
                    this.newDoc = {
                        DocTitle: "",
                        DocDesc: "",
                        TenantID: "",
                        SecureDocumentInd: false,
                        DocumentTags: [],
                        SubCategory: "",
                    }
                }
            },
            immediate: true
        },
        file: {
            handler: function (newFile) {
                if (newFile) {
                    if (this.newDoc.DocTitle !== "") { return }
                    this.newDoc.DocTitle = newFile.name
                }
            },
            immediate: true
        }
    }
}
</script>